import React from 'react';

import ButtonFlat from '../../ButtonFlat/ButtonFlat.js';
import { ITranslationContextValue } from '../../Translate/models/ITranslationContextValue.js';
import { IPagingButton } from '../models/IPagingButtons.js';

interface PageButtonProps {
	disabled?: boolean;
	pagingButton?: IPagingButton;
	label: string;
	buttonText: string;
	ariaControls?: string;
	onClick: () => void;
	translationContext?: ITranslationContextValue;
}

export const PageButton: React.FC<PageButtonProps> = ({
	disabled: initialDisabled,
	pagingButton,
	label,
	buttonText,
	ariaControls,
	onClick,
	translationContext,
}) => {
	const [disabled, setDisabled] = React.useState(initialDisabled);

	const enabledIconProps = pagingButton?.iconProps;
	const disabledIconProps = pagingButton?.disabledIconProps;
	const iconProps = disabled ? disabledIconProps : enabledIconProps;
	const ariaLabel = translationContext ? translationContext.translate(label) : label;
	const translatedButtonText = translationContext ? translationContext.translate(buttonText) : buttonText;

	React.useEffect(() => {
		setDisabled(initialDisabled);
	}, [initialDisabled]);

	return (
		<ButtonFlat
			onClick={onClick}
			aria-label={ariaLabel}
			disabled={disabled}
			iconProps={iconProps}
			aria-controls={ariaControls}
		>
			{!pagingButton?.hideLabel && <span aria-hidden="true">{translatedButtonText}</span>}
		</ButtonFlat>
	);
};
